<template>
    <div class="container pb-4 team-member">
        <div class="row pt-4">
            <div class="col-12">
                <div class="font-weight-bold team-member__title">
                    Team Members
                </div>
                <div class="team-member__desc">
                    Manage your team groups, and assign members to it.
                </div>
            </div>
        </div>

        <TeamsTeamMembers/>
    </div>
</template>

<script>
import TeamsTeamMembers from './TeamsTeamMembers'

export default {
    components: { TeamsTeamMembers },
}
</script>

<style lang="scss" scoped>
    .team-member {
        max-width: 768px;
        margin: 0 auto;

        &__title {
            color: #303030;
            font-family: Lato;
            font-size: 38px;
            font-weight: bold;
            letter-spacing: 0;
            line-height: 53.2px;
            text-align: center;
            margin-bottom: 16px;

            @media (max-width: 768px) {
                text-align: left;
                font-size: 24px;
                margin-bottom: 0;
            }
        }

        &__desc {
            color: #606064;
            font-family: "Open Sans", sans-serif;
            font-size: 20px;
            letter-spacing: 0;
            line-height: 28px;
            text-align: center;

            @media (max-width: 768px) {
                text-align: left;
                font-size: 14px;
                line-height: 20px;
            }
        }

        .tab-content {
            margin-top: 34px;
            height: 100%;
            overflow: auto;

            .nav-link {
                font-family: Lato;
                font-size: 16px;
                font-weight: bold;
                letter-spacing: 0;
                line-height: 19px;
                text-align: center;
                color: #808fa4;
                border-bottom: 1px solid #808fa4;
                padding-bottom: 20px;

                &.active {
                    color: #313131;
                    /* height: 100vh; */
                    /* border-bottom: 4px solid #ff375e; */
                    &::after {
                        content: "";
                        border-bottom: 4px solid #ff375e;
                        width: 100%;
                        height: 100%;
                        /* display: block; */
                        position: absolute;
                        left: 0;
                        top: 0;
                    }
                }
            }
        }

        select:disabled {
            opacity: 0.5 !important;
        }
    }

    .wfh-section-nav {
        justify-content: space-around;
        padding-top: 8px;
        display: flex;

        li {
            flex: 1;
            padding: 10px;
            text-align: center;
            border-bottom: 1px solid #D5D5D5;

            &.active {
                border-bottom: 4px solid #ff375e;

                a {
                    color: #313131;
                }
            }

            a {
                color: #808fa4;
                font-family: Lato;
                font-size: 16px;
                letter-spacing: 0;
                line-height: 19px;
                text-align: center;
            }
        }
    }
</style>
